import { render, staticRenderFns } from "./PromotionCompletion.vue?vue&type=template&id=368afb03&scoped=true"
import script from "./PromotionCompletion.vue?vue&type=script&lang=ts"
export * from "./PromotionCompletion.vue?vue&type=script&lang=ts"
import style0 from "./PromotionCompletion.vue?vue&type=style&index=0&id=368afb03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368afb03",
  null
  
)

export default component.exports